'use client';

import { Flex, Icon, Text } from '@/_components';
import { FC } from 'react';

export const OtherSignatureRequireToSign: FC = () => {
  return (
    <Flex gap={4} isColumn={true}>
      <Icon name="warning" color="secondary" size={20}></Icon>
      <Text textAlign="center" type="tiny" color="secondary">
        Your signature is not required, another user need to sign before you can
        submit the questionnaire.
      </Text>
    </Flex>
  );
};
